import { ReactNode } from 'react';

export type QuoteIconProps = {
  color?: string;
  width?: string | number;
  height?: string | number;
  defs?: ReactNode;
};

export function QuoteIcon({ color = 'inherit', width = 20, height = 15, defs = null }: QuoteIconProps) {
  return (
    <svg
      aria-hidden='true'
      fill='none'
      height={height}
      viewBox='0 0 20 15'
      width={width}
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8.18182 0L5.73864 4.71591C5.51136 5.17045 5.05682 5.68182 4.54545 5.96591C3.75 6.36364 3.18182 6.53409 3.29545 6.98864C3.40909 7.44318 3.80682 7.38636 4.60227 7.10227C5.28409 6.875 5.85227 6.81818 6.42045 6.81818H8.18182V15H0V7.61364C0 5.51136 0.852273 4.48864 3.29545 0H8.18182ZM20 0L17.5568 4.71591C17.3295 5.17045 16.875 5.68182 16.3636 5.96591C15.5682 6.36364 15 6.53409 15.1136 6.98864C15.2273 7.44318 15.625 7.38636 16.4205 7.10227C17.1023 6.875 17.6705 6.81818 18.2386 6.81818H20V15H11.8182V7.61364C11.8182 5.51136 12.6705 4.48864 15.1136 0H20Z'
        fill={color}
      />
      {defs}
    </svg>
  );
}
